import { ArrowRight, Flame, Shuffle, Target } from "lucide-react";
import { attemptsToday, masteryByPath, recommendNext } from "../lib/learningEngine";
import { StreakHeatmap } from "./StreakHeatmap";
import type { LearningExercise, LearningPath, LearningPathId, LearningState } from "../types";

export function HomePanel({
  state,
  exercises,
  paths,
  dailyGoalItems,
  onStartRun,
}: {
  state: LearningState;
  exercises: LearningExercise[];
  paths: LearningPath[];
  dailyGoalItems: number;
  onStartRun: (pathId: LearningPathId | "all") => void;
}) {
  const next = recommendNext(state, exercises, paths);
  const doneToday = attemptsToday(state);
  const mastery = masteryByPath(state, exercises);
  const minutes = Math.max(4, Math.ceil(Math.min(dailyGoalItems, Math.max(1, next?.due ?? dailyGoalItems)) * 1.5));

  return (
    <section className="home-panel">
      <div className="home-status">
        <span>
          <Flame size={16} />
          {state.streak} Tage aktiv
        </span>
        <span>
          <Target size={16} />
          {Math.min(doneToday, dailyGoalItems)}/{dailyGoalItems} heute
        </span>
        <StreakHeatmap state={state} />
      </div>

      <div className="home-cta-zone">
        <span className="eyebrow">Naechster Run</span>
        <h2>Eine gute Session, dann wieder raus.</h2>
        {next ? (
          <button className="primary-action home-primary-cta" onClick={() => onStartRun(next.pathId as LearningPathId)} type="button">
            Weiter: {next.label} - {next.due} faellig - ~{minutes} Min
            <ArrowRight size={20} />
          </button>
        ) : (
          <p>Gerade ist kein Lernpfad vorbereitet.</p>
        )}
        <button className="ghost-action home-mix-cta" onClick={() => onStartRun("all")} type="button">
          <Shuffle size={17} />
          Bunter Mix — querbeet aus allen Pfaden
        </button>
      </div>

      <div className="home-mastery-strip" aria-label="Meisterung-Kurzuebersicht">
        {paths.map((path) => {
          const stats = mastery[path.id] ?? { total: 0, mastery: 0, due: 0 };
          const average = stats.total ? Math.round((stats.mastery / stats.total) * 20) : 0;
          return (
            <article key={path.id}>
              <strong>{path.label}</strong>
              <span>{average}% Meisterung - {stats.due} faellig</span>
            </article>
          );
        })}
      </div>
    </section>
  );
}
